export default [
  { label: 'PRIMARY', value: 'PRIMARY' },
  { label: 'SECONDARY', value: 'SECONDARY' },
  { label: 'BOTH', value: 'BOTH' }
]
